module.exports = __webpack_public_path__ + "static/media/bootstrap.eb43fe0b.png";